import { Link } from "react-router-dom";
import styles from "./PageNotFound.module.scss";

const PageNotFound = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>404 - Page Not Found</h1>
      <p className={styles.message}>The page you are looking for does not exist.</p>

      <Link
        to="/dashboard"
        className={styles.link}
      >
        <p>Go back home</p>
      </Link>
    </div>
  );
};
export default PageNotFound;
